import alt from '../alt';
import modalAction from './modalAction';

class jpAction {
    constructor() {
        this.generateActions(
            'processing',
            'getJourneyPlannerSuccess',
            'selectMonth',
            'staffId',
            'updateEM',
            'warningMsg',
            'shouldListShow',
            'updateERPSuccess',
            'updateParkingSuccess',
            'updateMileageSuccess',
            'removeJPSuccess',
            'updateStatusSuccess',
            'updateReceiptSuccess',
            'updateErpReceiptSuccess',
            'updateRemarkSuccess',
            'clear',
            'closeListShow',
            'submitRecord',
            'approveAllSuccess',
        );
    }
    claimSubmit(year, month) {
        if (sessionStorage.getItem('ui')) {
            let queryParam = "?year=" + year + "&month=" + month;
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/journeyPlanner/notify' + queryParam, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({ title: "Message", content: "Claim successfully submitted" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Message", content: "Something went wrong. Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    getJourneyPlanner(staffId, year, month) {

        if (sessionStorage.getItem('ui')) {
            let queryParam = "?staffId=" + staffId + "&year=" + year + "&month=" + month;

            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/journeyPlanner' + queryParam, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.getJourneyPlannerSuccess(result);
                    } else {
                        //show success message
                        modalAction.modalContent({ title: "Message", content: "Viewing is restricted" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    exportJourneyPlanner(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/journeyPlanner', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "JPReport_" + staffId + "_" + year + "-" + (month + 1) + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
        }
        return true;
    }
    updateERP(id, value) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/ERP/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.updateERPSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "The ERP fare has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ erp: value }));
        }
        return true;
    }
    uploadReceipt(id, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/parking/receipt/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.updateReceiptSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Receipt has been uploaded" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    uploadERPReceipt(id, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/erp/receipt/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.updateErpReceiptSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Receipt has been uploaded" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    updateParking(id, value) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/parking/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.updateParkingSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Parking fare has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ parking: value }));
        }
        return true;
    }
    /*
    updateMileage(id, value) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/mileage/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.updateMileageSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Updated the mileage claim amount" });
                        modalAction.modalClose(true);
                    }else{
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ mileageClaim: value }));
        }
        return true;
        
    }
    */
    updateDistance(id, value, googleStart, googleEnd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/distance/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.updateMileageSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Updated the mileage distance & claim amount" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ distance: value, googleStart: googleStart, googleEnd: googleEnd }));
        }
        return true;

    }
    updateRemark(id, value) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/remark/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.updateRemarkSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Remark successfully added" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ remark: value }));
        }
        return true;

    }
    removeJp(id) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/journeyPlanner/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //this.removeJPSuccess(id);
                        this.updateStatusSuccess({ id: id, status: 4 });
                        //show success message
                        modalAction.modalContent({ title: "Removed", content: "Status has changed to removed" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }

    updateStatus(id, status) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/journeyPlanner/status/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        this.updateStatusSuccess({ id: id, status: status });

                        //show success message
                        //modalAction.modalContent({ title: "Successful", content: "Status has been updated" });
                        //modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ status: status }));
        }
        return true;
    }
    emailJustification(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/email/journeyPlanner/justification', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //let result = JSON.parse(xhttp.responseText);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Email successfully sent" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
        }
        return true;
    }
    emailApproved(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/email/journeyPlanner/approved', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //let result = JSON.parse(xhttp.responseText);
                        //show success message
                        modalAction.modalContent({ title: "Approved", content: "Email successfully sent" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
        }
        return true;
    }
    emailReject(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/email/journeyPlanner/reject', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({ title: "Rejected", content: "Email successfully sent" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
        }
        return true;
    }
    getSubmitRecord(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            let queryParam = "?staffId=" + staffId + "&year=" + year + "&month=" + month;
            xhttp.open("GET", '/v1/api/journeyPlanner/submitRecord' + queryParam, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        //show success message
                        this.submitRecord(result);
                    } else {

                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    approveAll(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/journeyPlanner/status/all', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({ title: "Approved", content: "Claims approved successfully" });
                        modalAction.modalClose(true);
                        this.approveAllSuccess({ staffId: staffId, year: year, month: month });
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Error", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
        }
    }
}
export default alt.createActions(jpAction);


// WEBPACK FOOTER //
// ./app/actions/jpAction.js